module.exports = __webpack_public_path__ + "img/breeio-logo-animated.0a63a4ce.svg";